'use client';
/** @jsxImportSource @emotion/react */

import type { InputAdornmentProps } from '@mui/material/InputAdornment';

import MuiInputAdornment from '@mui/material/InputAdornment';

export type { InputAdornmentProps };
export const InputAdornment = MuiInputAdornment;
